import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { NgModule } from '@angular/core';
import { ForgetResetEmailComponent } from './forget-reset-email/forget-reset-email.component';

export const AuthorizationRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/login',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'admin-login',
    component: LoginComponent,
  },
  {
    path: 'register',
    component: RegisterComponent,
  },
  // {
  //   path: 'admin-login',
  //   component: SuperAdminLoginComponent
  // },
  // {
  //   path: 'signup',
  //   component: SignupComponent,
  //   children: [
  //     {
  //       path: 'organisation-info',
  //       component: OrganisationInfoComponent
  //     },
  //     {
  //       path: 'signup-subscription',
  //       component: SignupSubscriptionComponent, resolve: { data: SignUpSubscriptionResolver }
  //     },
  //     {
  //       path: 'payment',
  //       component: PaymentComponent
  //     },
  //     {
  //       path: 'confirmation',
  //       component: SignupConfirmationComponent
  //     },
  //   ]
  // },
  {
    path: 'reset-password',
    component: ForgetResetEmailComponent,
  },
  {
    path: 'reset-password/:id',
    component: ForgetResetEmailComponent,
  },
  {
    path: 'forgot-password',
    component: ForgetResetEmailComponent,
  },
  {
    path: 'forgot-password/admin',
    component: ForgetResetEmailComponent,
  },
  {
    path: 'email-verification/:id',
    component: ForgetResetEmailComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(AuthorizationRoutes)],
  exports: [RouterModule],
})
export class AuthorizationRoutingModule {}
